<template>
  <div class="cms-youtube-cid">
    <el-dialog
      title="Insert a new Track"
      :visible="showTrackModal"
      width="500px"
      top="3vh"
      :modal="true"
      @close="setTrackModal(false)"
      @open="open"
    >
      <el-form label-position="top">
        <el-form-item label="Campaign">
          <el-select v-model="newTrack.campaign_id" filterable>
            <el-option
                v-for="campaign in campaigns.data"
                :key="campaign.campaign_id"
                :label="campaign.name"
                :value="campaign.campaign_id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="Label">
          <el-select v-model="selectedLabel" filterable
               @change="(value) => updateCidShare(getLabelDataByLabel(value))">
            <el-option
                v-for="labelData in labels.data"
                :key="labelData.label"
                :label="labelData.label"
                :value="labelData.label"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="CID Share">
          <el-input v-model="selectedCidShare" placeholder="CID Share" />
        </el-form-item>
        <el-form-item
          label="Track"
          :error="getValidationError('track_id')"
        >
          <el-select v-model="newTrack.track_ids" filterable multiple :disabled="!selectedLabel">
            <el-option
              v-for="track in labelTracks.data"
              :key="track.id"
              :label="track.title"
              :value="track.id"
            />
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button
          type="primary"
          size="mini"
          :loading="loading"
          @click="submit()"
        >
          Save
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'

export default {
  data() {
    return {
      active: false,
      newTrack: {
        track_ids: [],
        campaign_id: null,
        label_id: null,
      },
      selectedLabel: null,
      selectedCidShare: null
    }
  },
  computed: {
    ...mapState('revShareCampaigns', ['loading', 'track', 'showTrackModal', 'campaigns', 'labels', "labelTracks",'validation']),
  },
  watch: {
    selectedLabel(newVal) {
      if (newVal) {
        this.readLabelAssets(newVal)
      }
    }
  },

  methods: {
    ...mapActions('revShareCampaigns', ['insertTrack', 'readCampaigns', 'readLabels', 'readLabelAssets']),
    ...mapMutations('revShareCampaigns', ['setTrackModal','setValidation']),

    submit() {
      const payload = {
        campaign_id: this.newTrack.campaign_id,
        track_ids: this.newTrack.track_ids,
        cid_share:this.selectedCidShare,
        label_id: this.newTrack.label_id,
      };
      this.insertTrack(payload)
    },

    open(){
      this.readCampaigns()
      this.readLabels()
      this.newTrack = {
        title: '',
        campaign_id: null
      }
      this.selectedLabel = null
    },
    handleClose() {
      this.setTrackModal(false);  // Close the modal
      this.setValidation({});         // Reset validation state
    },
    // Method to get the first error message or empty string
    getValidationError(field) {
      const errors = this.validation[field];
      return errors && errors.length > 0 ? errors[0] : ''; // Get the first error message
    },
    getLabelDataByLabel(label) {
      console.log(this.labels.data.find(labelData => labelData.label === label));
      return this.labels.data.find(labelData => labelData.label === label);
    },
    updateCidShare(selected) {
      console.log(selected)
      if (selected) {
        this.selectedCidShare = selected.cid_share || null;
        this.newTrack.label_id = selected.label_id || null;
      } else {
        this.selectedCidShare = null;
        this.newTrack.label_id = null;
      }
    },
  }
}
</script>

<style scoped lang="scss">

</style>
